// extracted by mini-css-extract-plugin
export default {"supportersCoolio":"supportedBy_supportersCoolio__xJHzW","text":"supportedBy_text__EL6oQ","logos":"supportedBy_logos__1Va0y","logo":"supportedBy_logo__wCoHv"};